import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import useAuth from "./tools/useAuth";
import { Navigate } from "react-router-dom";
const ProtectedRoute = ({ redirectTo = "/ConnectionPage", children }) => {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: redirectTo, replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
